/**
 * delete-reminder-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeleteReminderRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_DELETE_REMINDER;
	public static tag : MessageTag = MessageTag.REQ_DELETE_REMINDER;

  constructor (
    public objectId : number,
    public notificationId : number
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/reminders/delete-reminder-request.ts